import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Motivo de Baixa',
        path: '/biblioteca/bibmotivobaixa',
        name: 'bibmotivobaixa',
        component: () => import('@/views/biblioteca/bibmotivobaixa/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_MOTIVOBAIXANOVO_MENU_1300801399],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Motivo de Baixa',
        path: '/biblioteca/bibmotivobaixa/cadastro/:id?',
        parent: 'bibmotivobaixa',
        name: 'bibmotivobaixa_create',
        component: () => import('@/views/biblioteca/bibmotivobaixa/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_MOTIVOBAIXANOVO_MENU_1300801399],
        },
        goesToMenu: true,
    },
]
